<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Set Password for {{username}}</v-card-title>

    <v-card-text>

        
        <v-text-field
            v-model="old_password"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show_password ? 'text' : 'password'"
            @click:append="show_password = !show_password"
            label="Current Password"
            v-show="ask_for_old_password"
        />

        
        <v-text-field
            v-model="new_password"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show_password ? 'text' : 'password'"
            hint="At least 7 characters"
            @click:append="show_password = !show_password"
            label="New Password"
        />

        <v-text-field
            v-model="new_password_confirm"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show_password ? 'text' : 'password'"
            @click:append="show_password = !show_password"
            label="Confirm Password"
        />

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="false"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            dialog: false,
            
            organization_id: null,
            employee_id: null,
            username: '',
            show_password: false,

            new_password: null,
            new_password_confirm: null,
            ask_for_old_password: false,
            old_password: null,
        }
    },

    methods: {
        showDialog(organization_id, employee_id, username, ask_for_old_password) 
        {
            this.organization_id = organization_id;    
            this.employee_id = employee_id;
            this.username = username;
            
            
            this.dialog = true;
            this.new_password = null;
            this.new_password_confirm = null;

            this.ask_for_old_password = ask_for_old_password === true;
        },
        
        onOk()
        {
            if ( this.new_password == null || this.new_password.length < 7 )
            {
                alert("Password must be at least 7 characters");
                return;
            }

            if ( this.new_password != this.new_password_confirm )
            {
                alert("Passwords do not match");
                return;
            }

           this.dialog = false;

            let set_password_data = {
                'organization_id' : this.organization_id,
                'employee_id' : this.employee_id,
                'new_password' : this.new_password,
                'old_password' : this.ask_for_old_password ? this.old_password : null,
            };

           this.$emit('ok', set_password_data);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>